import { addDays } from './quarantine';
export const QUEST_POOL = [
    { id: 'duel_1', icon: '⚔️', title: 'Play a duel', counter: 'duels', target: 1, group: 'duel' },
    { id: 'duel_win', icon: '🏆', title: 'Win a duel', counter: 'wins', target: 1, group: 'duel' },
    { id: 'duel_3', icon: '🔥', title: 'Play 3 duels', counter: 'duels', target: 3, group: 'duel' },
    { id: 'right_10', icon: '🎯', title: 'Get 10 answers right', counter: 'right', target: 10, group: 'right' },
    { id: 'right_20', icon: '🎯', title: 'Get 20 answers right', counter: 'right', target: 20, group: 'right' },
    { id: 'daily', icon: '🗓️', title: 'Play the Daily Quiz', counter: 'daily', target: 1, group: 'daily' },
    { id: 'solo', icon: '🧠', title: 'Finish a practice quiz', counter: 'solo', target: 1, group: 'solo' },
];
export const QUESTS_PER_DAY = 3;
const GROUPS = ['duel', 'right', 'daily', 'solo'];
const hash = (s) => {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++)
        h = Math.imul(h ^ s.charCodeAt(i), 16777619);
    return h >>> 0;
};
/** The day's quests: three of the four groups, one quest from each, the same for everyone on a date. */
export function questsFor(date) {
    const groups = [...GROUPS].sort((a, b) => hash(`${date}|group|${a}`) - hash(`${date}|group|${b}`)).slice(0, QUESTS_PER_DAY);
    const picked = groups.map(g => {
        const members = QUEST_POOL.filter(q => q.group === g);
        return members[hash(`${date}|pick|${g}`) % members.length];
    });
    return QUEST_POOL.filter(q => picked.includes(q));
}
export const emptyQuestDay = (date) => ({ date, duels: 0, wins: 0, right: 0, daily: 0, solo: 0 });
export const emptyQuestState = () => ({ day: emptyQuestDay(''), streak: { count: 0, lastDate: null } });
/** Today's counters: yesterday's progress never carries over. */
export const questDayFor = (day, date) => (day && day.date === date ? day : emptyQuestDay(date));
export function applyQuestEvent(day, event) {
    switch (event.type) {
        case 'duel': return { ...day, duels: day.duels + 1, wins: day.wins + (event.won ? 1 : 0) };
        case 'answers': return { ...day, right: day.right + Math.max(0, Math.floor(event.correct)) };
        case 'daily': return { ...day, daily: day.daily + 1 };
        case 'solo': return { ...day, solo: day.solo + 1 };
    }
}
export const questCount = (day, quest) => Math.min(quest.target, day[quest.counter]);
export const questDone = (day, quest) => day[quest.counter] >= quest.target;
export const questsDone = (day) => questsFor(day.date).filter(q => questDone(day, q)).length;
export const allQuestsDone = (day) => day.date !== '' && questsDone(day) === QUESTS_PER_DAY;
/** The streak after finishing every quest on `date`: the same day twice changes nothing, yesterday continues it, anything older starts again. */
export function bumpQuestStreak(streak, date) {
    if (streak.lastDate === date)
        return streak;
    return { count: streak.lastDate && addDays(streak.lastDate, 1) === date ? streak.count + 1 : 1, lastDate: date };
}
/** The streak as shown today: broken (0) once a whole day passed without finishing the quests. */
export function liveQuestStreak(streak, today) {
    if (!streak.lastDate)
        return 0;
    return streak.lastDate === today || addDays(streak.lastDate, 1) === today ? streak.count : 0;
}
